import { useState, useEffect } from "react";
import {
  Card,
  Form,
  Input,
  Button,
  Typography,
  message,
  Divider,
  Alert,
} from "antd";

import { useNavigate } from "react-router-dom";

import { encryptData, decryptData } from "../middleware/encryption";
import { encode } from "../middleware/encoding";

import logo from "../assets/logo.png";
import googleLogo from "../assets/google-logo.png";

import "antd/dist/reset.css";

const { Title, Text, Link } = Typography;

export default function Signup() {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const root = document.documentElement;

    const handleMouseMove = (e) => {
      const x = (e.clientX / window.innerWidth) * 100;
      const y = (e.clientY / window.innerHeight) * 100;

      root.style.setProperty("--x", `${x}%`);
      root.style.setProperty("--y", `${y}%`);
    };

    document.addEventListener("mousemove", handleMouseMove);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  const handleSubmit = (values) => {
    if (values.password !== values.confirmPassword) {
      message.error("Passwords do not match");
      return;
    }

    setLoading(true);

    const encryptedData = encryptData({
      name: values.name,
      email: values.email,
      mobileNumber: values.mobileNumber,
      password: values.password,
    });

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({ data: encryptedData }),
      redirect: "follow",
    };

    fetch(
      "https://api.app.exellius.com/api/auth/signup",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        setLoading(false);

        if (result.data) {
          const decryptedResponse = decryptData(result.data);

          if (decryptedResponse.token) {
            const encodedEmail = encode(
              decryptedResponse.user.email
            );

            navigate(`/${encodedEmail}/verify`);
          } else {
            message.error("Email address already exists");
            setError("Email address already exists");
          }
        } else {
          message.error(result.message || "Signup failed");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error(error);
        message.error("An error occurred during signup");
      });
  };

  return (
    <>
      <style>
        {`
          :root {
            --primary: #9856F2;
            --secondary: #31485A;
            --bg-1: #F9FAFB;
            --bg-2: #EEF2F7;
            --text-strong: #111827;
            --text-muted: #6B7280;
            --border: #E5E7EB;
          }

          body {
            margin: 0;
            font-family: Inter, sans-serif;
            background: linear-gradient(
              180deg,
              var(--bg-1) 0%,
              var(--bg-2) 100%
            );
            overflow-x: hidden;
          }

          .signup-page {
            min-height: 100vh;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            overflow: scrolled;
            padding: 30px 20px;
          }

          .signup-page::before {
            content: "";
            position: absolute;
            width: 600px;
            height: 600px;
            background: radial-gradient(
              circle,
              rgba(152, 86, 242, 0.18) 0%,
              rgba(152, 86, 242, 0.08) 40%,
              transparent 70%
            );
            top: var(--y, 20%);
            left: var(--x, 20%);
            transform: translate(-50%, -50%);
            filter: blur(25px);
            z-index: 0;
            transition: top 0.2s ease, left 0.2s ease;
          }

          .signup-page::after {
            content: "";
            position: absolute;
            width: 500px;
            height: 500px;
            background: radial-gradient(
              circle,
              rgba(152, 86, 242, 0.12) 0%,
              transparent 70%
            );
            bottom: -120px;
            right: -120px;
            filter: blur(25px);
            z-index: 0;
          }

          .signup-container {
            width: 100%;
            max-width: 530px;
            position: relative;
            z-index: 2;
          }

          .logo-wrapper {
            text-align: center;
            margin-bottom: 24px;
          }

          .logo-image {
            height: 52px;
            width: auto;
            margin-bottom: 8px;
          }

          .tagline {
            font-size: 16px;
            color: var(--text-muted);
            margin-top: 3px;
            margin-bottom: 36px;
          }

          .signup-card {
           border-radius: 22px !important;
  border: none !important;
  box-shadow: 0 18px 45px rgba(0,0,0,0.06) !important;
  padding: 14px !important;
  background: #fff;

  max-height: 92vh;
  overflow-y: scroll;
          }

          .signup-title {
            margin-bottom: 6px !important;
            font-size: 28px !important;
            font-weight: 700 !important;
            color: var(--text-strong) !important;
          }

          .signup-subtitle {
            color: var(--text-muted);
            font-size: 14px;
            margin-bottom: 6px;
          }

          .signup-value {
            color: var(--secondary);
            font-size: 13px;
            margin-bottom: 24px;
          }

          .custom-label {
            display: block;
            margin-bottom: 8px;
            font-size: 13px;
            font-weight: 600;
            color: var(--secondary);
          }

          .custom-input {
            height: 48px;
            border-radius: 12px !important;
            border: 1px solid var(--border) !important;
            font-size: 14px;
          }

          .custom-input:hover,
          .custom-input:focus,
          .ant-input-affix-wrapper-focused {
            border-color: var(--primary) !important;
            box-shadow: 0 0 0 3px rgba(152,86,242,0.15) !important;
          }

          .signup-btn {
            height: 50px !important;
            border: none !important;
            border-radius: 12px !important;
            background: linear-gradient(
              135deg,
              #9856F2,
              #7C3AED
            ) !important;
            font-size: 15px;
            font-weight: 600;
            box-shadow: 0 6px 14px rgba(152,86,242,0.28);
          }

          .signup-btn:hover {
            transform: translateY(-1px);
          }

          .google-btn {
            height: 48px;
            border-radius: 12px !important;
            border: 1px solid var(--border) !important;
            font-size: 14px;
            font-weight: 500;
            background: #fff;
          }

          .google-btn:hover {
            background: #F9FAFB !important;
            border-color: #d1d5db !important;
          }

          .footer-text {
            text-align: center;
            margin-top: 18px;
            color: var(--text-muted);
            font-size: 16px;
          }

          .footer-link {
            color: var(--primary) !important;
            font-weight: 600;
          }

          .trust-text {
            margin-top: 16px;
            text-align: center;
            color: var(--text-muted);
            font-size: 12px;
            line-height: 1.7;
          }

          .ant-divider {
            color: #9CA3AF !important;
            font-size: 12px !important;
          }

          @media (max-width: 576px) {
            .signup-card {
              padding: 4px !important;
            }

            .signup-title {
              font-size: 24px !important;
            }
          }
        `}
      </style>

      <div className="signup-page">
        <div className="signup-container">
          <div className="logo-wrapper">
            <img
              src={logo}
              alt="Exellius"
              className="logo-image"
            />

            <div className="tagline">
              Data Intelligence Platform
            </div>
          </div>

          <Card className="signup-card">
            <Title level={2} className="signup-title">
              Create account
            </Title>

            <div className="signup-subtitle">
              Start building your pipeline
            </div>

            <div className="signup-value">
              Access 200M+ verified B2B contacts globally
            </div>

            <Form
              form={form}
              onFinish={handleSubmit}
              layout="vertical"
            >
              <Form.Item
                label={<span className="custom-label">Email</span>}
                name="email"
                rules={[
                  {
                    required: true,
                    type: "email",
                    message: "Please enter a valid email",
                  },
                ]}
              >
                <Input
                  className="custom-input"
                  placeholder="you@company.com"
                />
              </Form.Item>

              <Form.Item
                label={<span className="custom-label">Name</span>}
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Please enter your name",
                  },
                ]}
              >
                <Input
                  className="custom-input"
                  placeholder="Enter your name"
                />
              </Form.Item>

              <Form.Item
                label={
                  <span className="custom-label">
                    Mobile Number
                  </span>
                }
                name="mobileNumber"
              >
                <Input
                  className="custom-input"
                  placeholder="Enter mobile number"
                />
              </Form.Item>

              <Form.Item
                label={
                  <span className="custom-label">
                    Password
                  </span>
                }
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Please enter your password",
                  },
                ]}
              >
                <Input.Password
                  className="custom-input"
                  placeholder="••••••••"
                />
              </Form.Item>

              <Form.Item
                label={
                  <span className="custom-label">
                    Confirm Password
                  </span>
                }
                name="confirmPassword"
                dependencies={["password"]}
                rules={[
                  {
                    required: true,
                    message: "Please confirm your password",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      return !value ||
                        getFieldValue("password") === value
                        ? Promise.resolve()
                        : Promise.reject(
                            new Error(
                              "Passwords do not match"
                            )
                          );
                    },
                  }),
                ]}
              >
                <Input.Password
                  className="custom-input"
                  placeholder="••••••••"
                />
              </Form.Item>

              {error !== false ? (
                <Alert
                  message={error}
                  type="error"
                  style={{
                    marginBottom: 16,
                    borderRadius: 10,
                  }}
                />
              ) : null}

              <Form.Item style={{ marginBottom: 16 }}>
                <Button
                  htmlType="submit"
                  type="primary"
                  block
                  loading={loading}
                  className="signup-btn"
                >
                  Create Account
                </Button>
              </Form.Item>

              <Divider>OR</Divider>

              <Button
                block
                className="google-btn"
                onClick={() =>
                  (window.location.href =
                    "https://api.app.exellius.com/api/auth/google")
                }
              >
                <img
                  src={googleLogo}
                  alt="Google"
                  style={{
                    width: 18,
                    marginRight: 10,
                    verticalAlign: "middle",
                  }}
                />
                Continue with Google
              </Button>

              <div className="trust-text">
                Trusted by global sales teams
                <br />
                Secure signup • Privacy protected
              </div>

              
            </Form>
          </Card>

          <div className="footer-text">
                Already have an account?{" "}
                <Link
                  className="footer-link"
                  onClick={() => navigate("/login")}
                >
                  Log in
                </Link>
              </div>
        </div>
      </div>
    </>
  );
}